import { Toast } from '@revenuemarket/ui';
import { useMutation } from '@tanstack/react-query';
import { useRouter } from 'next/router';

import { CalculatorFormData, emailResend, payoutEstimate } from '~apis/estimate-calculate';

const useCalculatorForm = () => {
  const id = useRouter().query.id as string;
  const payoutEstimationMutation = useMutation({
    mutationKey: ['payoutEstimation'],
    mutationFn: (data: CalculatorFormData) => payoutEstimate(data),
  });

  const emailResendMutation = useMutation({
    mutationFn: (calculationId: number) => emailResend(calculationId),
  });

  const handleResendEmail = (calculationId: number) => {
    emailResendMutation.mutateAsync(calculationId).then(() => {
      Toast.success('이메일을 전송하였습니다.');
    });
  };

  return {
    payoutEstimationMutation,
    handleResendEmail,
  };
};

export default useCalculatorForm;
